/**
 * Cálculos puros del presupuesto que el comercial descarga desde el carrito.
 * Trabaja sobre las líneas tal y como las devuelve el api del carrito
 * (sellingPrice = precio neto del cliente, basePrice = precio de tarifa, tax = % IVA).
 */

export const DIAS_VALIDEZ_PRESUPUESTO = 15;

/** Descuento en % de una línea respecto a la tarifa (null si no hay descuento). */
export const lineDiscountPercent = (product) => {
  const base = Number(product?.basePrice) || 0;
  const selling = Number(product?.sellingPrice) || 0;
  if (base <= 0 || selling >= base) return null;
  return ((1 - selling / base) * 100);
};

/** Importe neto (sin IVA) de una línea. Los regalos de pack van a 0. */
export const lineNetAmount = (product) => {
  if (product?.packOrigin) return 0;
  return (Number(product?.sellingPrice) || 0) * (Number(product?.quantity) || 0);
};

/**
 * Desglose del IVA por tipo: [{ rate, base, amount }] ordenado por tipo descendente.
 * Solo informativo: los totales del presupuesto salen del api (cart.subtotal/tax/total),
 * que es lo mismo que verá el cliente al tramitar el pedido.
 */
export const vatBreakdown = (products = []) => {
  const byRate = new Map();
  products.forEach((product) => {
    const net = lineNetAmount(product);
    if (net <= 0) return;
    const rate = Number(product.tax) || 0;
    const current = byRate.get(rate) ?? { rate, base: 0, amount: 0 };
    current.base += net;
    current.amount += net * rate / 100;
    byRate.set(rate, current);
  });
  return [...byRate.values()].sort((a, b) => b.rate - a.rate);
};

/** Referencia legible del presupuesto: PRE-AAAAMMDD-HHMM-<cliente>. */
export const quoteReference = (numCliente, date = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  const stamp = `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
  const time = `${pad(date.getHours())}${pad(date.getMinutes())}`;
  return `PRE-${stamp}-${time}${numCliente ? `-${numCliente}` : ''}`;
};

export const quoteValidUntil = (date = new Date(), days = DIAS_VALIDEZ_PRESUPUESTO) => {
  const until = new Date(date);
  until.setDate(until.getDate() + days);
  return until;
};
